import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { QuestionService } from 'src/app/service/question.service';
import { AnswerService } from 'src/app/service/answer.service';
import { NotifierService } from 'angular-notifier';
import { QuestionTypes } from 'src/app/classes/question-types';
import Keyboard from 'simple-keyboard';
import KeyboardLayouts from 'simple-keyboard-layouts';


@Component({
  selector: 'app-multiple-choice-single',
  templateUrl: './multiple-choice-single.component.html',
  styleUrls: ['./multiple-choice-single.component.scss']
})
export class MultipleChoiceSingleComponent implements OnInit {
  public ansBody:any = {
    question_label:'',
    question_name:'',
    answer_text:{},
  }
  public slicedTabOption:any = {
    'options':[],
    'tabCount':0
  }
  public isSwitchTab:boolean = false;
  public componentType:string = "";
  @ViewChild('simpleKeyboardRef', {static:false}) simpleKeyboardRef: ElementRef | undefined;
  @ViewChild('input', {static:false}) inputRef: ElementRef | undefined;
  public keyboard: Keyboard | undefined;
  public keyboardLayouts: any;
  public isKeyboardReInstanciated : boolean =false;
  layoutsObj: any;
  selectedLayout: string = 'english';
  value = '';

  constructor(
    public qService:QuestionService,
    public aService:AnswerService,
    public notifier:NotifierService,
    
  ) { 
      this.keyboardLayouts = new KeyboardLayouts();
      this.layoutsObj = this.keyboardLayouts.get();
    this.componentType = this.qService.questionType.MULTIPLE_CHOICE_SINGLE
    this.qService.refreshAnsBody
    .subscribe((question_type:string) =>{
      if (question_type == this.componentType) {
        this.resetAnsBody();
      }
    })
  }

  ngOnInit(): void {
    if (this.qService.questionView.isImgOption) {
      this.getSlicedOption();
    }
  }

  next(){
    if(Object.keys(this.ansBody.answer_text).length == 0)
    {
      this.notifier.notify('error',"Please select a value");
    }
    else
    {
      if(this.ansBody.answer_text['text'] == 'Other'){
        if(this.ansBody.answer_text['other_text'] == '' || this.ansBody.answer_text['other_text'] == undefined) {
          this.notifier.notify('error',"Please Enter Other Text");
          return;
        }
      }
      this.ansBody.question_label = this.qService.currentQuestion.question_label;
      this.ansBody.question_name = this.qService.currentQuestion.question_name;
      this.aService.submitAnswer(this.ansBody);
      // this.resetAnsBody();
      // setTimeout(() => {
      //   this.resetAnsBody();
      // }, 100);
    }
    
  }

  radioOptionSwitch(text:any){
    this.ansBody.answer_text = text;
  }

  onOpenKeyboard() {
    if (this.keyboard) {
      this.keyboard.resetRows()
    }
    this.selectedLayout = 'english';
    this.isKeyboardReInstanciated = true;
    this.keyboard = new Keyboard(".simple-keyboard",{
      onChange: input => this.onChange(input),
      onKeyPress: (button: any) => this.onKeyPress(button),
      layout: {
        default: [this.layoutsObj[this.selectedLayout].layout.default][0],
        shift: [this.layoutsObj[this.selectedLayout].layout.shift][0],
        numeric: ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 {enter}'],
        decimal: ['1 2 3', '4 5 6', '7 8 9', '.00 0 .', '{bksp} {enter}'],
      },
      buttonTheme: [
        {
          class: 'hg-enter',
          buttons: '{enter}',
        },
      ],
      display: {
        '{enter}': '↩',
        '{bksp}': '⌫',
        '{space}': ' ',
        '{shift}': '⇪',
        '{lock}': '🄰',
        '{tab}': '⇄',
      },
    });

    if (this.qService.currentQuestion.misc && this.qService.currentQuestion.misc.ans_type && this.qService.currentQuestion.misc.ans_type == "numeric") {
      this.keyboard.setOptions({
        inputName: 'numericInput',
        layoutName: 'numeric',
      });
    }

    if (this.keyboard && this.ansBody.answer_text && this.ansBody.answer_text.other_text != '') {
      this.keyboard.setInput(this.ansBody.answer_text.other_text);
    }
    // console.log("onOpenKeyboard this.keyboard",this.keyboard);
  }

  onCloseKeboard(){
    if (this.keyboard) {
      this.keyboard.resetRows()
    }
    this.isKeyboardReInstanciated = false;
  }

  onChange = (input: string) => {
    this.value = input;
    this.ansBody.answer_text['other_text'] = input;
  };


  onKeyPress = (button: string) => {
    if (button === '{shift}' || button === '{lock}') this.handleShift();
  };

  onInputViaWithoutVirtualKeyboard = (event:any) =>{
    if (this.keyboard) {
      this.keyboard.setInput(event.target.value);
    }
    this.ansBody.answer_text['other_text'] = event.target.value;
    // this.value = event.target.value;


  }

  onInputChange = (event: any) => {
    if (this.keyboard) {
      this.keyboard.setInput(event.target.value);
    }
    // this.ansBody.answer_text['other_text'] = event.target.value;
    // this.value = event.target.value;
  }

  handleShift = () => {
    if (this.keyboard) {
      let currentLayout = this.keyboard.options.layoutName;
      console.log("this.keyboard.options.layoutName ",this.keyboard.options.layoutName)
      let shiftToggle = currentLayout === "default" ? "shift" : "default";
  
      this.keyboard.setOptions({
        layoutName: shiftToggle
      });
   
    }
  };

  resetAnsBody(){
    this.ansBody ={
      question_label:'',
      question_name:'',
      answer_text:{},
    }
    console.log("reset called",this.qService.questionView.isImgOption)
    this.slicedTabOption = {
      'options':[],
      'tabCount':0
    }
    if (this.qService.questionView.isImgOption) {
      this.getSlicedOption();
    }
    var ele = document.getElementById('focus-row');
    if (ele) {
      ele.scrollIntoView();
    }
  }

  getSlicedOption(){
    this.isSwitchTab = true;
    console.log(this.qService.currentQuestion.options)
    let totalTabs = Math.ceil(this.qService.currentQuestion.options.length / this.qService.questionView.optionSize);
    this.slicedTabOption.options = this.qService.currentQuestion.options.slice(this.slicedTabOption.tabCount*this.qService.questionView.optionSize,(this.slicedTabOption.tabCount + 1)*this.qService.questionView.optionSize);
    this.slicedTabOption.tabCount++;
    if (this.slicedTabOption.tabCount == totalTabs) {
      this.isSwitchTab = false;

    }
  }

}
